/** @format */

const config = {
  baseUrl: "https://ebus.ir/service/api/v1/",
  // baseUrl: "https://ebus.ir/develop/api/v1/",
  // baseUrl: "http://localhost:8080/api/v1/",

  // docUrl: "https://ebus.ir/service/",
};

export default config
